<div class="bread-crumb-image w-100 pb-3 pt-3" [ngClass]="isShipmentPage || status?'bread-crumb-image-background':'bread-crumb-image'">
<div class="container">
  <!-- uncomment for navigation breadcrumbs -->
  <div #parent>
    <ol class="breadcrumb ml-1 p-0 mb-0">
      <li class="breadcrumb-item">
        <a (click)="homeLinkClick(true)" [routerLink]="['']">{{  'home.productHeader.bhpConnect' | cxTranslate }}</a>
      </li>
      <div class="ml-1" *ngIf="pageDetailTitle">
        <li class="breadcrumb-item">
          <a href="">  - {{ pageDetailTitle}}</a>
        </li>
      </div>
      <div class="ml-1">
        <li class="breadcrumb-item">
          <a href="/shipmentvms/shipmentvmslist/portside" *ngIf="this.disp=='ship'">  - {{ navigationData}}</a>
          <a href="/shipmentvms/shipmentvmslist/bondedwarehouse" *ngIf="this.disp=='bondedwarehouse'">  - {{ navigationData}}</a>
          <a href="/shipmentinspection/shipmentinspectionlist/portside" *ngIf="this.disp=='inspectionShip'">  - {{ navigationData}}</a>
          <a href="/shipmentinspection/shipmentinspectionlist/bondedwarehouse" *ngIf="this.disp=='inspectionBondedwarehouse'">  - {{ navigationData}}</a>
          <a href="/dvl-screening-list/dvl-screening-list/portside" *ngIf="this.disp=='screeningPortside'">  - {{ navigationData}}</a>
          <a href="/dvl-screening-list/dvl-screening-list/bondedwarehouse" *ngIf="this.disp=='screeningBondedwarehouse'">  - {{ navigationData}}</a>
          <a href="/batches/dvl-tracking-list" *ngIf="this.disp=='team'">  - {{ pageTitle}}</a>
          <a href="/batches/dvl-tracking-list" *ngIf="this.disp=='batch'">  - {{ pageTitle}}</a>
          <a href="/shipmentvms/quality-inspection" *ngIf="this.disp=='qualityInspection'">  - {{ pageTitle}}</a>
          <a href="/" *ngIf="this.disp=='home'">  - {{ pageTitle}}</a>
          <a href="/bilateralCargos" *ngIf="this.disp=='bilateral'">  - {{ pageTitle}}</a>


        </li>
      </div>
      <ng-template ngFor let-route [ngForOf]="parent.breadcrumbs">
        <li *ngIf="!route.terminal" class="breadcrumb-item">
          <a href="" [routerLink]="[route.url]">{{ route.route.data.translation | cxTranslate }}</a>
        </li>
        <li *ngIf="route.terminal" class="breadcrumb-item " aria-current="page">{{ route.route.data.translation | cxTranslate }}</li>
      </ng-template>
    </ol>
  </div>
  <div class="d-flex justify-content-between ">
    <h2 class="breadcrumb-page" >{{pageTitle}}</h2>
    <div class="visible-xs">
      <div *ngIf="isShipmentDetailPage && status" class="status d-flex">
        <div class="mr-4"><div class="small text-secondary">{{'shipment.ShipmentNumber' | cxTranslate}}</div><div class="strong">{{status?.shipmentId}}</div></div>
        <!--<div class="mr-4"><div class="small text-secondary">{{'shipment.Incoterm' | cxTranslate}}</div><div class="strong">{{status?.incotermPart2}}</div></div>
        <div class="mr-4"><div class="small text-secondary">{{'shipment.Shipagent' | cxTranslate}}</div><div class="strong">{{status?.shipAgent}}</div></div>-->
        <div><div class="small text-secondary">{{'shipment.Status' | cxTranslate}}</div><div [shipmentStatus]="status?.shipmentStatus">{{status?.shipmentStatusName?.split("_").join(" ") }}</div></div>
        <!-- <svg width="212" height="42" viewBox="0 0 212 42" [attr.fill]="status?.shipmentStatus=='Arrived at load port'?'#6C757D':'white'" xmlns="http://www.w3.org/2000/svg"  style="position: relative; left: 150px;z-index: 3;">
          <path d="M0.5 0.5H196.022L211.375 21L196.022 41.5H0.5V0.5Z" stroke="#CED4DA" />
          <text x="45%" y="60%" text-anchor="middle" [attr.fill]="status?.shipmentStatus=='Arrived at load port'?'white':'#6C757D'" >Arrived at load port</text>
        </svg>
        <svg width="212" height="42" viewBox="0 0 212 42" [attr.fill]="status?.shipmentStatus=='Berthed at load port'?'#6C757D':'white'" xmlns="http://www.w3.org/2000/svg"  style="position: relative; left: 100px;z-index: 2;">
          <path d="M0.5 0.5H196.022L211.375 21L196.022 41.5H0.5V0.5Z" stroke="#CED4DA" />
          <text x="60%" y="60%" text-anchor="middle" [attr.fill]="status?.shipmentStatus=='Berthed at load port'?'white':'#6C757D'"  >Berthed at load port</text>
        </svg>
        <svg width="212" height="42" viewBox="0 0 212 42" [attr.fill]="status?.shipmentStatus=='Vessel sailed'?'#F77F00':'white'" xmlns="http://www.w3.org/2000/svg"  style="position: relative; left: 50px;z-index: 1;">
          <path d="M0.5 0.5H196.022L211.375 21L196.022 41.5H0.5V0.5Z" stroke="#CED4DA" />
          <text x="60%" y="60%" text-anchor="middle" [attr.fill]="status?.shipmentStatus=='Vessel sailed'?'white':'#6C757D'"  >Vessel sailed</text>
        </svg>
        <svg width="212" height="42" viewBox="0 0 212 42" [attr.fill]="status?.shipmentStatus=='Arrived at destination'?'#28A745':'white'" xmlns="http://www.w3.org/2000/svg" >
          <rect x="0.5" y="0.5" width="211" height="41" stroke="#CED4DA" />
          <text x="60%" y="60%" text-anchor="middle" fill="#6C757D" [attr.fill]="status?.shipmentStatus=='Arrived at destination'?'white':'#6C757D'" >Arrived at destination</text>
        </svg> -->
      </div>
    </div>
  </div>
</div>
</div>


